import { render, staticRenderFns } from "./CreateEatingStudy.vue?vue&type=template&id=c59476ba&scoped=true&"
import script from "./CreateEatingStudy.vue?vue&type=script&lang=js&"
export * from "./CreateEatingStudy.vue?vue&type=script&lang=js&"
import style0 from "./CreateEatingStudy.vue?vue&type=style&index=0&id=c59476ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59476ba",
  null
  
)

export default component.exports